export const settings = {
  title: 'Sales settings',
  subtitle: 'Enable or disable features for your project. Changes apply immediately after saving.',
  searchPlaceholder: 'Search settings',
  sidebarSection: 'Management',
  sidebarNghiepVu: 'Operations',
  sidebarCuaHang: 'Store',
  sidebarTichHop: 'Integrations',
  sidebarCucBo: 'Local',
  loadError: 'Failed to load sales settings.',
  noData: 'No settings in this group.',
  noSearchResult: 'No matching settings found.',
  readOnlyHint: 'You have view-only access to settings.',
  configureDetail: 'Configure details',
  configureShort: 'Configure',
  detailSectionTitle: 'Detailed options',
  detailModalTitles: {
    BAN_HANG_HET_TON_KHO: 'Allow transactions when out of stock',
    GIAO_DICH_HANG_NGUNG_KINH_DOANH: 'Allow transactions with discontinued products',
    TU_DONG_TAO_PHIEU_XUAT: 'Auto-create stock-out vouchers',
    TU_DONG_TAO_PHIEU_NHAP: 'Auto-create stock-in vouchers',
    KHONG_THAY_DOI_THOI_GIAN: 'Lock transaction timestamps',
    DAT_HANG: 'Order settings',
  },
  helpMore: 'View note',
  tabSummary: '{active}/{total} enabled',
  statusOn: 'On',
  statusOff: 'Off',
  saving: 'Saving...',
  savedSuccess: 'Settings saved.',
  updateError: 'Update failed.',
  saoChep: {
    button: 'Copy to other projects',
    title: 'Copy transaction settings',
    description:
      'All transaction settings of the current project (including auto debt closing) will overwrite the selected projects.',
    selectAll: 'Select all',
    clear: 'Clear',
    empty: 'You do not belong to any other project.',
    action: 'Copy ({count})',
    needSelected: 'Select at least one project.',
    success: 'Copied settings to {count} project(s).',
    loadError: 'Could not load projects.',
    saveError: 'Copy settings failed.',
  },
  tichHopVanChuyen: {
    title: 'API connections',
    description:
      'Configure GHTK, Viettel Post and Shopee Express (SPX) to create shipments and receive webhooks. Enable a carrier to select it on delivery invoices.',
    configure: 'Configure',
    empty: 'Not configured — click Configure to enter the carrier token.',
    connected: 'Connected',
    inactive: 'Inactive',
    production: 'Production',
    sandbox: 'Sandbox',
    checkConnection: 'Check',
    edit: 'Edit',
    webhook: 'Webhook',
    lastError: 'Latest error',
    notConfigured: 'Not configured',
    turnOn: 'Enable — the carrier becomes selectable on delivery invoices',
    turnOff: 'Disable — hide the carrier from delivery invoices',
    environment: 'Environment',
    token: 'Token',
    lastCheck: 'Last checked',
    copyWebhook: 'Copy webhook URL to register with the carrier',
    connectionInfo: 'Connection details',
    pickupAddress: 'Default pickup address',
  },
  tabs: {
    hangHoa: 'Products',
    doiTac: 'Partners',
    giaoDich: 'Transactions',
    giaoHang: 'Delivery',
    thongBaoZalo: 'Zalo notifications',
    logo: 'Logo',
    mauIn: 'Print templates',
    quyTacMa: 'Code rules',
    diaChiLayHang: 'Pickup addresses',
    formatSo: 'Number format',
    caiDatBang: 'Table settings',
    thongBao: 'Notifications',
    phamViXemDon: 'Order visibility',
  },
  phamViXemDon: {
    title: 'Order visibility',
    description:
      'Configure which staff can view orders/invoices of other staff, and share customer invoices with others.',
    loadError: 'Failed to load order visibility settings.',
    loadOptsError: 'Failed to load staff / customers.',
    save: 'Save',
    savedSuccess: 'Order visibility saved.',
    saveError: 'Failed to save order visibility.',
    sameUserError: 'Grantor and viewer must be different.',
    pickUser: 'Select staff',
    pickUsers: 'Select staff to view',
    pickCustomers: 'Select customers',
    nguoiBan: {
      title: 'View by salesperson',
      hint: 'Pick staff A, then the salespeople whose orders/invoices A may view.',
      viewer: 'Staff being configured (A)',
      targets: 'May view orders of',
    },
    khachHang: {
      title: 'Share invoices by customer',
      hint: 'Staff A opens customers 1, 2 for staff B — unshared customers stay hidden from B.',
      nguoiChoPhep: 'Staff granting access (A)',
      viewer: 'Staff allowed to view (B)',
      customers: 'Shared customers',
    },
  },
  cauHinhFields: {
    choPhepDatHangHetTonKho: 'Allow orders when out of stock',
    banHangKhiDaDatHang: 'Allow sales/transfers when the product is already ordered',
    choPhepChuyenChiNhanh: 'Allow transferring orders to another branch',
    banHang: 'Sales',
    datHang: 'Orders',
    hoaDon: 'Invoices',
    traHang: 'Returns',
    datHangNhap: 'Purchase orders',
    nhapHang: 'Goods receipt',
    traHangNhap: 'Purchase returns',
    chuyenHang: 'Stock transfer',
    phieuNhanHang: 'Goods receipt note',
    yeuCauSuaChua: 'Repair request',
    yeuCauXuatHoaDon: 'Invoice request',
    nhapKho: 'Stock in',
    xuatKho: 'Stock out',
    phieuThu: 'Receipt voucher',
    phieuChi: 'Payment voucher',
    kiemKe: 'Stock count',
    xuatHuy: 'Write-off',
    soQuy: 'Cash book',
    kiemKho: 'Stock take',
    sanXuat: 'Production',
  },
  thoiGianGiaoDich: {
    khongChoPhep: 'Not allowed',
    choPhep: 'Allowed',
    gioiHan: 'Limit',
    truoc: 'Before',
    sau: 'After',
    ngay: 'days',
  },
  logoChiNhanh: {
    title: 'Branch logos',
    description: 'Each active branch has its own logo, used when printing invoices and slips.',
    empty: 'No active branches in this project.',
    choose: 'Choose logo',
    paste: 'Paste logo',
    pasteHint: 'Drag and drop an image, paste from clipboard, or use an http(s) link.',
    dragDrop: 'Drop image here',
    remove: 'Remove logo',
    emptySlot: 'No logo yet — choose or drop an image',
    attachedSummary: 'Logos set for {attached}/{total} branches',
    loadError: 'Failed to load branch logos.',
    saveError: 'Failed to save branch logo.',
    applyToAll: 'Apply to all',
    applyToSelected: 'Apply to selected',
    setSameForAll: 'Set same for all branches',
    setSameMenuHint: 'Pick a source branch (with logo)',
    selectBranch: 'Select',
    selectedCount: '{count} selected',
    selectAll: 'Select all',
    clearSelect: 'Clear selection',
    applyConfirmTitle: 'Confirm apply logo',
    applyConfirmAction: 'Apply',
    applyConfirmAll: 'Apply the logo from “{source}” to all {count} branches?',
    applyConfirmSelected: 'Apply the logo from “{source}” to {count} selected branches?',
    applySuccess: 'Updated logo for {count} branches.',
    applyPartial: 'Updated {ok}/{total} branches. Some failed.',
    applyNeedSource: 'Need a branch that already has a logo to copy from.',
    applyNeedSelected: 'Select at least one target branch.',
    applying: 'Applying…',
  },
  quyTacMa: {
    title: 'Code rules',
    description: 'Auto-generate or enter codes manually for each type. Saved per project.',
    summary: 'Auto-generate {auto}/{total} code types',
    loadError: 'Failed to load code rules.',
    saveError: 'Failed to save code rules.',
    groups: {
      hangHoa: 'Products',
      doiTac: 'Partners',
      giaoDich: 'Transactions',
    },
    items: {
      hangHoa: 'Product code',
      khachHang: 'Customer code',
      nhaCungCap: 'Supplier code',
      hoaDon: 'Invoice code',
      datHang: 'Order code',
      traHang: 'Return code',
      phieuNhapKho: 'Goods receipt code',
      phieuXuatKho: 'Goods issue code',
      chuyenHang: 'Transfer code',
      kiemKe: 'Stock-take code',
      phieuThu: 'Receipt voucher code',
      phieuChi: 'Payment voucher code',
      yeuCauSuaChua: 'Repair request code',
      yeuCauXuatHoaDon: 'Invoice request code',
    },
    itemDesc: {
      hangHoa: 'SP + 8 digits (SP00000001). Leave blank to auto-generate, or type a code.',
      khachHang: 'KH + 7 digits (KH0000001). Leave blank to auto-generate, or type a code.',
      nhaCungCap: 'Current default: NCC + 4 digits (NCC0001).',
      hoaDon: 'Regular sale HD0000001. Repair-request sale HDSC0000001.',
      datHang: 'DH0000001.',
      traHang: 'From invoice THHD0000001 / THHDSC0000001. Quick return TH0000001. Carrier return CHHD0000001 / CHHDSC0000001.',
      phieuNhapKho: 'NK0000001.',
      phieuXuatKho: 'XK0000001.',
      chuyenHang: 'TF0000001.',
      kiemKe: 'KK0000001.',
      phieuThu: 'THU0000001.',
      phieuChi: 'CHI0000001.',
      yeuCauSuaChua: 'YCSC0000001.',
      yeuCauXuatHoaDon: 'YCXV0000001.',
    },
    cheDoTitle: 'How codes are created',
    cheDo: {
      tuSinh: 'Auto-generate',
      nhapTay: 'Manual',
    },
    cheDoHint: {
      tuSinh: 'The system generates a code from the rule below when the field is empty.',
      nhapTay: 'Users must enter a code when creating a record.',
    },
    ruleTitle: 'Auto-generate rule',
    prefix: 'Prefix',
    prefixRequired: 'Enter a prefix when auto-generate is selected.',
    padLength: 'Digit length',
    includeNguon: 'Include source',
    includeNguonHint: 'Insert a source code (BT, DH, HD…) between the prefix and the number.',
    nguonMau: 'Preview source',
    includeYymm: 'Include year-month',
    includeYymmHint: 'Insert YYMM from the created date, e.g. 2609.',
    previewLabel: 'Sample code',
    previewManual: 'Entered by the user',
    rowAuto: 'Auto · {preview}',
    rowManual: 'Entered manually on create',
    columns: {
      loai: 'Code type',
      cheDo: 'Creation',
    },
  },
  numberFormatHint:
    'Saved in this browser (localStorage). Applies to UI display and Excel cell formats. Excel keeps raw numbers; thousand/decimal separators follow the machine locale; decimal places follow this setting.',
  numberFormatDecimals: 'Decimals',
  numberFormatPreview: 'Preview',
  numberFormatReset: 'Reset to default',
  numberFormatSaveSuccess: 'Number format saved',
  numberFormatResetSuccess: 'Number format reset to default',
  numberFormatVnd: 'VND amount',
  numberFormatVndHint: 'Fixed rounding (default {default})',
  numberFormatUsd: 'USD amount',
  numberFormatUsdHint: 'Max decimals, trim zeros (default {default})',
  numberFormatRmb: 'RMB / CNY amount',
  numberFormatRmbHint: 'Max decimals, trim zeros (default {default})',
  numberFormatWeight: 'Weight (kg)',
  numberFormatWeightHint: 'Max decimals, trim zeros (default {default})',
  numberFormatVolume: 'Volume (m³)',
  numberFormatVolumeHint: 'Max decimals, trim zeros (default {default})',
  numberFormatGeneral: 'General number',
  numberFormatGeneralHint: 'Max decimals, trim zeros (default {default})',
  tablePrefsHint:
    'Use the column button on each card (same as list toolbars) to configure layouts. Export/import across machines or reset to defaults.',
  tablePrefsStatusSaved: 'Custom layout saved',
  tablePrefsStatusDefault: 'Using defaults',
  tablePrefsProduct: 'Products',
  tablePrefsKhachHang: 'Customers',
  tablePrefsNhaCungCap: 'Suppliers',
  tablePrefsHoaDon: 'Invoices',
  tablePrefsDatHang: 'Orders',
  tablePrefsTraHang: 'Returns',
  tablePrefsCongNoKh: 'Customer receivables',
  tablePrefsCongNoDon: 'Receivables by invoice',
  tablePrefsCongNoThanhToan: 'Receivables payments',
  tablePrefsCongNoHoanTien: 'Receivables refunds',
  tablePrefsKiemKe: 'Stocktake',
  tablePrefsTaiKhoanQuy: 'Cash accounts',
  tablePrefsPhieuThu: 'Receipts',
  tablePrefsPhieuChi: 'Payments',
  tablePrefsBangGiaHangHoa: 'Product price list',
  tablePrefsYeuCauXuatHoaDon: 'Invoice requests',
  browserPrefsResetAll: 'Clear all',
  browserPrefsReset: 'Reset default',
  browserPrefsPathLabel: 'Screen',
  browserPrefsStorageLabel: 'Key',
  browserPrefsResetOneSuccess: 'Layout cleared — defaults will be used',
  browserPrefsResetAllSuccess: 'All table layouts cleared on this device',
  browserPrefsExport: 'Export',
  browserPrefsImport: 'Import',
  browserPrefsExportSuccess: 'Exported {count} setting(s)',
  browserPrefsExportError: 'Export failed',
  browserPrefsImportSuccess: 'Imported {count} setting(s)',
  browserPrefsImportError: 'Invalid file or import failed',
  browserPrefsClearOrphans: 'Clear {count} old key(s)',
  browserPrefsClearOrphansSuccess: 'Deleted {count} orphan key(s)',
  browserPrefsOpenScreen: 'Open screen',
  browserPrefsOpenShort: 'Open',
  browserPrefsConfigureOnList: 'Configure columns',
  browserPrefsEditJson: 'JSON',
  browserPrefsResetShort: 'Reset',
  browserPrefsJsonTitle: 'Edit localStorage JSON',
  browserPrefsJsonSaveSuccess: 'JSON saved',
  browserPrefsJsonInvalid: 'Invalid JSON',
  tuDongChotCongNo: {
    title: 'Automatic receivables close',
    description:
      'Close receivables for every active customer. Pick the day the job runs and the date balances are closed through.',
    lapLai: 'Repeat',
    thangChay: 'Run month',
    ngayChay: 'Run day',
    ngayTrongThang: 'Day of month',
    gio: 'Hour',
    phut: 'Minute',
    ngayChot: 'Close-through date',
    thangChot: 'Month to close',
    thangSo: 'Month {n}',
    ngaySo: 'day {n}',
    lap: {
      hangThang: 'Every month',
      hangNam: 'Every year',
    },
    moc: {
      dauThang: 'Start of month',
      cuoiThang: 'End of month',
      ngayCuThe: 'A specific day',
    },
    mocChot: {
      cungNgayChay: 'Same day as the run',
      cuoiThangTruoc: 'End of the month before the run',
      cuoiNamTruoc: 'End of the previous year (31 Dec)',
      cuoiThangNamTruocChon: 'End of a month in the previous year',
      cuoiThangNamTruoc: 'end of month {n} last year',
    },
    cum: {
      cuoiThangNam: 'the end of month {thang}',
      dauThangNam: 'the start of month {thang}',
      ngayThang: 'day {n} of month {thang}',
      cuoiThangThang: 'the end of every month',
      dauThangThang: 'the start of every month',
      ngayMoiThang: 'day {n} of every month',
    },
    tomTat: '{lap}, {cum} at {gio}. Close through: {mocChot}.',
    lanToi: 'Next run: {chay}, close receivables through {chot}.',
    ngayNgan: 'If the month has no such day, the last day of that month is used.',
  },
}
